import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Notification_Service } from 'src/app/Services/Notifications/notification.service';
import { AuthService, InternalUserModel } from 'src/app/Services/AuthService/auth-service.service';

declare var $: any;
declare var kendo: any;

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent implements OnInit {
  title = 'Registration-Portal';
  responseOutput = 'Please enter your credentials.'

  constructor(private router: Router, private notificationService: Notification_Service, private authService:AuthService) { }
  ngOnInit() {
    $(document).ready(function () {
      $("#authentication-wrapper").hover(function () {
        kendo.fx($("#authentication-wrapper")).zoom("in").startValue(1).endValue(1.05).play();
      }, () => {
        kendo.fx($("#authentication-wrapper")).zoom("out").endValue(1).startValue(1.05).play();
      });
      
      $("#authentication-wrapper").focus();
      $( "#authentication-wrapper" ).click();
      setTimeout(x => {
        //focus on the the Username
        $("input.k-textbox")[0].focus(); 
      }, 300);
    })
  }

  enterCredentials(a: any, b: any)  {
        this.authService.signIn(a, b)

      // kendo.fx($("#terminal")).zoom("in").startValue(1).endValue(1.2).play();
      // this.responseOutput = 'Login Attempt Failed. Please enter your credentials.';
      // setTimeout(() => {
      //   kendo.fx($("#terminal")).zoom("out").endValue(1).startValue(1.2).play();
      // }, 2300);
      //this.notificationService.errorNotif("Login Attempt Failed. Please enter your credentials.");
  }
}
